import { render, staticRenderFns } from "./DisplayFile.vue?vue&type=template&id=e817cbb0"
import script from "./DisplayFile.vue?vue&type=script&lang=js"
export * from "./DisplayFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports